import React from "react";
import { LoanSummaryContainer } from "../../../containers";
import { withAppLayout } from "../../../hoc";
import ManageEmployeeDistributionContainer from "../../../containers/Distribution/ManageEmployeeDistribution/ManageEmployeeDistribution";
import WithdrawalSummaryContainer from "../../../containers/Distribution/WithdrawalSummaryContainer/WithdrawalSummaryContainer";
import { ManageDistributionProvider } from "../../../contexts";
const LoanSummary = (props) => {
  return (
    // <ManageDistributionProvider>
    <LoanSummaryContainer {...props} />
    // </ManageDistributionProvider>
  );
};

export default LoanSummary;
